import { svg } from 'lit';

const symbol = svg`<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"><path fill="currentcolor" d="M11.5 18A6.51 6.51 0 015 11.5a.5.5 0 011 0A5.5 5.5 0 1011.5 6a.5.5 0 010-1 6.5 6.5 0 010 13z"/><path fill="currentcolor" d="M8.68 10.85a.5.5 0 01-.71 0L5.5 8.38 3 10.85a.5.5 0 01-.71 0 .48.48 0 010-.7l2.85-2.82a.48.48 0 01.7 0l2.83 2.83a.48.48 0 01.01.69z" fill-rule="evenodd"/></svg>`;

export { symbol as default };
